/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { SPARKLE_ANIMATION_KEY } from './gameData';
import UIAssetKeys from './UIAssetKeys';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  fixPivot(mainTex, SwipeAnimation.key, SwipeAnimation.frames);

  scene.anims.create({
    defaultTextureKey: SPARKLE_ANIMATION_KEY,
    key: 'sparkle',
    frames: SPARKLE_ANIMATION_KEY
  });
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 */
export function addStartAnimationToSprite(sprite, play = true) {
  const animationData = SwipeAnimation;
  const animationKey = 'start';
  const animationFramesData = animationData.animations.start;
  if (animationFramesData.frames.length === 1) {
    sprite.stop();

    // this animation only has 1 frame, just set it
    sprite.setFrame(`${SwipeAnimation.key}${animationFramesData.frames[0]}`);
    return;
  }
  if (sprite.anims.exists(animationKey)) {
    if (play) sprite.play(animationKey);
    return;
  }

  const frames = [];
  animationFramesData.frames.forEach(frameNum => frames.push({ frame: `${SwipeAnimation.key}${frameNum.toString()}` }));
  sprite.anims.create(
    {
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frameRate: (animationFramesData.framerate ?? 24) / animationFramesData.speed,
      key: animationKey,
      frames
    }
  );

  sprite.on(`${Phaser.Animations.Events.ANIMATION_COMPLETE_KEY}start`, () => {
    sprite.setFrame(`${SwipeAnimation.key}${animationData.animations[animationFramesData.next].frames[0]}`);
  });
  if (play) sprite.play(animationKey);
}


// this data comes from the original game; this is the CreateJs sprite sheet animation export
export const SwipeAnimation = {
  key: 'IntroSwipeAnimation/',
  frames: [
    [0, 0, 1024, 128, 0, -28, -79],
    [0, 128, 1024, 128, 0, -28, -79],
    [0, 256, 1024, 128, 0, -28, -79],
    [0, 384, 1024, 128, 0, -28, -79],
    [0, 512, 1024, 128, 0, -28, -79],
    [0, 640, 1024, 128, 0, -28, -79],
    [0, 768, 1024, 128, 0, -28, -79],
    [0, 896, 1024, 128, 0, -28, -79],
    [0, 1024, 1024, 128, 0, -28, -79],
    [0, 1152, 1024, 128, 0, -28, -79]
  ],
  animations: {
    start: {
      frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      next: 'Finish',
      speed: 0.6
    },
    Finish: { frames: [9], speed: 1 }
  }
};